export function getLanguageMeta() {
    return { locale: 'IN', currency: 'INR', country: 'IN', symbol: '₹' }
}
